export default "__VITE_ASSET__DWJ4SgbB__"